import { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

const modalRoot = document.getElementById("modal-root");

/**
 * This mounts the component outside of the app-root
 * mostly used for the modals, to get out of the app-root css scope
 */
class ModalRootPortal extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export default ModalRootPortal;



// WEBPACK FOOTER //
// ./src/modules/root/modal-root-portal.js